import { useLocation } from "@tanstack/react-router";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "~/components/ui/card";
import { ProjectItem } from "./ProjectItem";

interface Project {
  name: string;
  url: string;
  description: string;
}

export function ProjectsCard() {
  const location = useLocation();

  // Language detection (same pattern as AboutCard)
  const getLanguage = () => {
    const segments = location.pathname.split("/").filter(Boolean);
    const langs = ["uz", "ru", "en"];
    return langs.includes(segments[0]) ? segments[0] : "oz";
  };

  // Multi-language content
  const content = {
    "uz-Latn": {
      title: "Boshqa loyihalarimiz",
      projects: [
        {
          name: "TVinfo.uz",
          url: "https://tvinfo.uz",
          description:
            "Bugun, ertaga va keyingi hafta uchun to'liq teledasturlar.",
        },
        {
          name: "DostavkaInfo",
          url: "https://dostavkainfo.uz",
          description:
            "Taomlar, dorilar, kitoblar va boshqa uy uchun kerakli bo'lgan narsalarni yetkazib berish xizmatlari bor servislar.",
        },
        {
          name: "Imlo.uz",
          url: "https://imlo.uz",
          description:
            "Lotin va kirill alifbosidagi o'zbekcha so'zlarning imlosini tekshirish imkonini beruvchi o'zbek tilining imlo lug'ati. Ma'lumotlar bazasida 87 000 dan ortiq so'z mavjud.",
        },
        {
          name: "Izoh.uz",
          url: "https://izoh.uz",
          description:
            "O'zbek tilining xalqona izohli lug'ati 35 000 dan ortiq so'zlarning ma'nolari ibora va misollar bilan keltirilgan.",
        },
        {
          name: "Maqollar.uz",
          url: "https://maqollar.uz",
          description:
            "Maqol va naqllarning eng katta kolleksiyasi. Har bir maqol uchta tilda (o'zbek, rus, ingliz).",
        },
        {
          name: "Ismlar.com",
          url: "https://ismlar.com",
          description:
            "O'zbek Ismlarning to'liq, batafsil ma'nosi, kelib chiqishi, shakllari. O'zingiz va yaqinlaringizni ismlari ma'nosini bilib oling.",
        },
        {
          name: "Latifa.uz",
          url: "https://latifa.uz",
          description:
            "Har kuni eng sara latifalar va kulguli rasmlar. O'zbek tilidagi kulgu markazi!",
        },
        {
          name: "Onmap.uz",
          url: "https://onmap.uz",
          description:
            "Valyutani yuqori kursda almashtirish uchun yaqin punktlarni aniqlab beruvchi servis. Punkt joylashuvini kartada ko'rsatadi.",
        },
        {
          name: "Uztelegram.com",
          url: "https://uztelegram.com",
          description:
            "O'zbekcha telegram kanallarining eng katta katalogi. Faqt faol kanallar, ruknlarda va batafsil statistikasi bilan.",
        },
      ],
    },
    "uz-Cyrl": {
      title: "Бошқа лойиҳаларимиз",
      projects: [
        {
          name: "TVinfo.uz",
          url: "https://tvinfo.uz",
          description:
            "Бугун, эртага ва кейинги ҳафта учун тўлиқ теледастурлар.",
        },
        {
          name: "DostavkaInfo",
          url: "https://dostavkainfo.uz",
          description:
            "Таомлар, дорилар, китоблар ва бошқа уй учун керакли бўлган нарсаларни етказиб бериш хизматлари бор сервислар.",
        },
        {
          name: "Imlo.uz",
          url: "https://imlo.uz",
          description:
            "Лотин ва кирилл алифбосидаги ўзбекча сўзларнинг имлосини текшириш имконини берувчи ўзбек тилининг имло луғати. Маълумотлар базасида 87 000 дан ортиқ сўз мавжуд.",
        },
        {
          name: "Izoh.uz",
          url: "https://izoh.uz",
          description:
            "Ўзбек тилининг халқона изоҳли луғати 35 000 дан ортиқ сўзларнинг маънолари ибора ва мисоллар билан келтирилган.",
        },
        {
          name: "Maqollar.uz",
          url: "https://maqollar.uz",
          description:
            "Мақол ва нақлларнинг энг катта коллексияси. Ҳар бир мақол учта тилда (ўзбек, рус, инглиз).",
        },
        {
          name: "Ismlar.com",
          url: "https://ismlar.com",
          description:
            "Ўзбек Исмларнинг тўлиқ, батафсил маъноси, келиб чиқиши, шакллари. Ўзингиз ва яқинларингизни исмлари маъносини билиб олинг.",
        },
        {
          name: "Latifa.uz",
          url: "https://latifa.uz",
          description:
            "Ҳар куни энг сара латифалар ва кулгули расмлар. Ўзбек тилидаги кулгу маркази!",
        },
        {
          name: "Onmap.uz",
          url: "https://onmap.uz",
          description:
            "Валютани юқори курсда алмаштириш учун яқин пунктларни аниқлаб берувчи сервис. Пункт жойлашувини картада кўрсатади.",
        },
        {
          name: "Uztelegram.com",
          url: "https://uztelegram.com",
          description:
            "Ўзбекча телеграм каналларининг энг катта каталоги. Фақт фаол каналлар, рукнларда ва батафсил статистикаси билан.",
        },
      ],
    },
    ru: {
      title: "Другие наши проекты",
      projects: [
        {
          name: "TVinfo.uz",
          url: "https://tvinfo.uz",
          description:
            "Полная телепрограмма на сегодня, завтра и следующую неделю.",
        },
        {
          name: "DostavkaInfo",
          url: "https://dostavkainfo.uz",
          description:
            "Сервисы доставки еды, лекарств, книг и других необходимых для дома вещей.",
        },
        {
          name: "Imlo.uz",
          url: "https://imlo.uz",
          description:
            "Орфографический словарь узбекского языка для проверки правописания слов на латинице и кириллице. В базе данных более 87 000 слов.",
        },
        {
          name: "Izoh.uz",
          url: "https://izoh.uz",
          description:
            "Народный толковый словарь узбекского языка с значениями более 35 000 слов, фразами и примерами.",
        },
        {
          name: "Maqollar.uz",
          url: "https://maqollar.uz",
          description:
            "Крупнейшая коллекция пословиц и поговорок. Каждая пословица на трех языках (узбекский, русский, английский).",
        },
        {
          name: "Ismlar.com",
          url: "https://ismlar.com",
          description:
            "Полные, подробные значения узбекских имен, их происхождение и формы. Узнайте значения своего имени и имен близких.",
        },
        {
          name: "Latifa.uz",
          url: "https://latifa.uz",
          description:
            "Каждый день лучшие анекдоты и смешные картинки. Центр юмора на узбекском языке!",
        },
        {
          name: "Onmap.uz",
          url: "https://onmap.uz",
          description:
            "Сервис для поиска ближайших пунктов обмена валюты по выгодному курсу. Показывает расположение пунктов на карте.",
        },
        {
          name: "Uztelegram.com",
          url: "https://uztelegram.com",
          description:
            "Крупнейший каталог узбекских телеграм-каналов. Только активные каналы с рубриками и подробной статистикой.",
        },
      ],
    },
    "en-US": {
      title: "Our other projects",
      projects: [
        {
          name: "TVinfo.uz",
          url: "https://tvinfo.uz",
          description:
            "Complete TV schedule for today, tomorrow, and next week.",
        },
        {
          name: "DostavkaInfo",
          url: "https://dostavkainfo.uz",
          description:
            "Delivery services for food, medicines, books, and other household necessities.",
        },
        {
          name: "Imlo.uz",
          url: "https://imlo.uz",
          description:
            "Uzbek spelling dictionary for checking the spelling of Uzbek words in Latin and Cyrillic alphabets. Database contains over 87,000 words.",
        },
        {
          name: "Izoh.uz",
          url: "https://izoh.uz",
          description:
            "Popular explanatory dictionary of the Uzbek language with meanings of over 35,000 words, phrases, and examples.",
        },
        {
          name: "Maqollar.uz",
          url: "https://maqollar.uz",
          description:
            "The largest collection of proverbs and sayings. Each proverb in three languages (Uzbek, Russian, English).",
        },
        {
          name: "Ismlar.com",
          url: "https://ismlar.com",
          description:
            "Complete, detailed meanings of Uzbek names, their origins and forms. Learn the meanings of your name and your loved ones' names.",
        },
        {
          name: "Latifa.uz",
          url: "https://latifa.uz",
          description:
            "Daily best jokes and funny pictures. Humor center in Uzbek language!",
        },
        {
          name: "Onmap.uz",
          url: "https://onmap.uz",
          description:
            "Service for finding nearby currency exchange points with the best rates. Shows the location of exchange points on the map.",
        },
        {
          name: "Uztelegram.com",
          url: "https://uztelegram.com",
          description:
            "The largest catalog of Uzbek Telegram channels. Only active channels with categories and detailed statistics.",
        },
      ],
    },
  };

  const langMap: Record<string, keyof typeof content> = {
    oz: "uz-Latn",
    uz: "uz-Cyrl",
    ru: "ru",
    en: "en-US",
  };

  const currentLang = getLanguage();
  const currentContent = content[langMap[currentLang]] || content["uz-Latn"];

  return (
    <Card className="shrink-0">
      <CardHeader>
        <CardTitle>{currentContent.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4">
          {currentContent.projects.map((project, index) => (
            <ProjectItem
              key={index}
              name={project.name}
              url={project.url}
              description={project.description}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
